import { z } from 'zod';

export const merchantOnboardingCompletedNotificationSchema = z.object({
    type: z.literal('merchant/onboarding-completed'),
    payload: z.object({
        practiceId: z.uuid(),
    }),
});
